import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (failureCount, error) => {
        const status = (error as { status?: number }).status
        return (!status || status >= 500) && failureCount < 2
      },
      refetchOnWindowFocus: false,
    },
  },
})
